export default __webpack_public_path__ + "static/media/rum.430c6ba3.svg";